"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultAdminPermissions = exports.getDefaultManagerPermissions = exports.getDefaultStaffPermissions = exports.getDefaultMemberPermissions = void 0;
const types_1 = require("../typings/types");
const CAPEventDefault = {
    type: types_1.AccountType.CAPEVENT,
    FlightAssign: types_1.Permissions.FlightAssign.NO,
    MusterSheet: types_1.Permissions.MusterSheet.NO,
    AssignTasks: types_1.Permissions.AssignTasks.NO,
    AdministerPT: types_1.Permissions.AdministerPT.NO,
    MemberSearch: types_1.Permissions.MemberSearch.NO,
    ManageEvent: types_1.Permissions.ManageEvent.NONE,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPEventStaff = {
    type: types_1.AccountType.CAPEVENT,
    FlightAssign: types_1.Permissions.FlightAssign.YES,
    MusterSheet: types_1.Permissions.MusterSheet.YES,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    AdministerPT: types_1.Permissions.AdministerPT.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.ADDDRAFTEVENTS,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPEventManager = {
    type: types_1.AccountType.CAPEVENT,
    FlightAssign: types_1.Permissions.FlightAssign.YES,
    MusterSheet: types_1.Permissions.MusterSheet.YES,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    AdministerPT: types_1.Permissions.AdministerPT.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    ScanAdd: types_1.Permissions.ScanAdd.YES,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPEventAdmin = {
    type: types_1.AccountType.CAPEVENT,
    FlightAssign: types_1.Permissions.FlightAssign.YES,
    MusterSheet: types_1.Permissions.MusterSheet.YES,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    AdministerPT: types_1.Permissions.AdministerPT.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    ScanAdd: types_1.Permissions.ScanAdd.YES,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    PermissionManagement: types_1.Permissions.PermissionManagement.FULL,
    CreateNotifications: types_1.Permissions.Notify.GLOBAL,
    RegistryEdit: types_1.Permissions.RegistryEdit.YES,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.YES,
};
const CAPSquadronDefault = {
    type: types_1.AccountType.CAPSQUADRON,
    FlightAssign: types_1.Permissions.FlightAssign.NO,
    MusterSheet: types_1.Permissions.MusterSheet.NO,
    PTSheet: types_1.Permissions.PTSheet.NO,
    PromotionManagement: types_1.Permissions.PromotionManagement.NONE,
    AssignTasks: types_1.Permissions.AssignTasks.NO,
    AdministerPT: types_1.Permissions.AdministerPT.NO,
    MemberSearch: types_1.Permissions.MemberSearch.NO,
    ManageEvent: types_1.Permissions.ManageEvent.NONE,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    ProspectiveMemberManagement: types_1.Permissions.ProspectiveMemberManagement.NONE,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPSquadronStaff = {
    type: types_1.AccountType.CAPSQUADRON,
    FlightAssign: types_1.Permissions.FlightAssign.YES,
    MusterSheet: types_1.Permissions.MusterSheet.YES,
    PTSheet: types_1.Permissions.PTSheet.YES,
    PromotionManagement: types_1.Permissions.PromotionManagement.FULL,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    AdministerPT: types_1.Permissions.AdministerPT.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.ADDDRAFTEVENTS,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    ProspectiveMemberManagement: types_1.Permissions.ProspectiveMemberManagement.NONE,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPSquadronManager = {
    type: types_1.AccountType.CAPSQUADRON,
    FlightAssign: types_1.Permissions.FlightAssign.YES,
    MusterSheet: types_1.Permissions.MusterSheet.YES,
    PTSheet: types_1.Permissions.PTSheet.YES,
    PromotionManagement: types_1.Permissions.PromotionManagement.FULL,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    AdministerPT: types_1.Permissions.AdministerPT.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    ProspectiveMemberManagement: types_1.Permissions.ProspectiveMemberManagement.FULL,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPSquadronAdmin = {
    type: types_1.AccountType.CAPSQUADRON,
    FlightAssign: types_1.Permissions.FlightAssign.YES,
    MusterSheet: types_1.Permissions.MusterSheet.YES,
    PTSheet: types_1.Permissions.PTSheet.YES,
    PromotionManagement: types_1.Permissions.PromotionManagement.FULL,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    AdministerPT: types_1.Permissions.AdministerPT.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    ProspectiveMemberManagement: types_1.Permissions.ProspectiveMemberManagement.FULL,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    PermissionManagement: types_1.Permissions.PermissionManagement.FULL,
    CreateNotifications: types_1.Permissions.Notify.GLOBAL,
    RegistryEdit: types_1.Permissions.RegistryEdit.YES,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.YES,
};
const CAPGroupDefault = {
    type: types_1.AccountType.CAPGROUP,
    AssignTasks: types_1.Permissions.AssignTasks.NO,
    MemberSearch: types_1.Permissions.MemberSearch.NO,
    ManageEvent: types_1.Permissions.ManageEvent.NONE,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPGroupStaff = {
    type: types_1.AccountType.CAPGROUP,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.ADDDRAFTEVENTS,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPGroupManager = {
    type: types_1.AccountType.CAPGROUP,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    ScanAdd: types_1.Permissions.ScanAdd.YES,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
};
const CAPGroupAdmin = {
    type: types_1.AccountType.CAPGROUP,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    ScanAdd: types_1.Permissions.ScanAdd.YES,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    PermissionManagement: types_1.Permissions.PermissionManagement.FULL,
    CreateNotifications: types_1.Permissions.Notify.GLOBAL,
    RegistryEdit: types_1.Permissions.RegistryEdit.YES,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.YES,
};
const CAPWingDefault = {
    type: types_1.AccountType.CAPWING,
    AssignTasks: types_1.Permissions.AssignTasks.NO,
    MemberSearch: types_1.Permissions.MemberSearch.NO,
    ManageEvent: types_1.Permissions.ManageEvent.NONE,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
    CreateEventAccount: types_1.Permissions.CreateEventAccount.NO,
};
const CAPWingStaff = {
    type: types_1.AccountType.CAPWING,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.ADDDRAFTEVENTS,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
    CreateEventAccount: types_1.Permissions.CreateEventAccount.NO,
};
const CAPWingManager = {
    type: types_1.AccountType.CAPWING,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    ScanAdd: types_1.Permissions.ScanAdd.YES,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
    CreateEventAccount: types_1.Permissions.CreateEventAccount.NO,
};
const CAPWingAdmin = {
    type: types_1.AccountType.CAPWING,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    ScanAdd: types_1.Permissions.ScanAdd.YES,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    PermissionManagement: types_1.Permissions.PermissionManagement.FULL,
    CreateNotifications: types_1.Permissions.Notify.GLOBAL,
    RegistryEdit: types_1.Permissions.RegistryEdit.YES,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.YES,
    CreateEventAccount: types_1.Permissions.CreateEventAccount.YES,
};
const CAPRegionDefault = {
    type: types_1.AccountType.CAPREGION,
    AssignTasks: types_1.Permissions.AssignTasks.NO,
    MemberSearch: types_1.Permissions.MemberSearch.NO,
    ManageEvent: types_1.Permissions.ManageEvent.NONE,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
    CreateEventAccount: types_1.Permissions.CreateEventAccount.NO,
};
const CAPRegionStaff = {
    type: types_1.AccountType.CAPREGION,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.ADDDRAFTEVENTS,
    EventContactSheet: types_1.Permissions.EventContactSheet.NO,
    ORMOPORD: types_1.Permissions.ORMOPORD.NO,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.NO,
    EventLinkList: types_1.Permissions.EventLinkList.NO,
    ManageTeam: types_1.Permissions.ManageTeam.NONE,
    FileManagement: types_1.Permissions.FileManagement.NONE,
    ScanAdd: types_1.Permissions.ScanAdd.NO,
    AttendanceView: types_1.Permissions.AttendanceView.PERSONAL,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
    CreateEventAccount: types_1.Permissions.CreateEventAccount.NO,
};
const CAPRegionManager = {
    type: types_1.AccountType.CAPREGION,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    ScanAdd: types_1.Permissions.ScanAdd.YES,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    PermissionManagement: types_1.Permissions.PermissionManagement.NONE,
    CreateNotifications: types_1.Permissions.Notify.NO,
    RegistryEdit: types_1.Permissions.RegistryEdit.NO,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.NO,
    CreateEventAccount: types_1.Permissions.CreateEventAccount.NO,
};
const CAPRegionAdmin = {
    type: types_1.AccountType.CAPREGION,
    AssignTasks: types_1.Permissions.AssignTasks.YES,
    MemberSearch: types_1.Permissions.MemberSearch.YES,
    ManageEvent: types_1.Permissions.ManageEvent.FULL,
    EventContactSheet: types_1.Permissions.EventContactSheet.YES,
    ORMOPORD: types_1.Permissions.ORMOPORD.YES,
    AssignTemporaryDutyPositions: types_1.Permissions.AssignTemporaryDutyPosition.YES,
    EventLinkList: types_1.Permissions.EventLinkList.YES,
    ManageTeam: types_1.Permissions.ManageTeam.FULL,
    FileManagement: types_1.Permissions.FileManagement.FULL,
    ScanAdd: types_1.Permissions.ScanAdd.YES,
    AttendanceView: types_1.Permissions.AttendanceView.OTHER,
    PermissionManagement: types_1.Permissions.PermissionManagement.FULL,
    CreateNotifications: types_1.Permissions.Notify.GLOBAL,
    RegistryEdit: types_1.Permissions.RegistryEdit.YES,
    ViewAccountNotifications: types_1.Permissions.ViewAccountNotifications.YES,
    CreateEventAccount: types_1.Permissions.CreateEventAccount.YES,
};
const DefaultPermissions = {
    [types_1.AccountType.CAPEVENT]: CAPEventDefault,
    [types_1.AccountType.CAPSQUADRON]: CAPSquadronDefault,
    [types_1.AccountType.CAPGROUP]: CAPGroupDefault,
    [types_1.AccountType.CAPWING]: CAPWingDefault,
    [types_1.AccountType.CAPREGION]: CAPRegionDefault,
};
const StaffPermissions = {
    [types_1.AccountType.CAPEVENT]: CAPEventStaff,
    [types_1.AccountType.CAPSQUADRON]: CAPSquadronStaff,
    [types_1.AccountType.CAPGROUP]: CAPGroupStaff,
    [types_1.AccountType.CAPWING]: CAPWingStaff,
    [types_1.AccountType.CAPREGION]: CAPRegionStaff,
};
const ManagerPermissions = {
    [types_1.AccountType.CAPEVENT]: CAPEventManager,
    [types_1.AccountType.CAPSQUADRON]: CAPSquadronManager,
    [types_1.AccountType.CAPGROUP]: CAPGroupManager,
    [types_1.AccountType.CAPWING]: CAPWingManager,
    [types_1.AccountType.CAPREGION]: CAPRegionManager,
};
const AdminPermissions = {
    [types_1.AccountType.CAPEVENT]: CAPEventAdmin,
    [types_1.AccountType.CAPSQUADRON]: CAPSquadronAdmin,
    [types_1.AccountType.CAPGROUP]: CAPGroupAdmin,
    [types_1.AccountType.CAPWING]: CAPWingAdmin,
    [types_1.AccountType.CAPREGION]: CAPRegionAdmin,
};
const getDefaultMemberPermissions = (accountType) => DefaultPermissions[accountType];
exports.getDefaultMemberPermissions = getDefaultMemberPermissions;
const getDefaultStaffPermissions = (accountType) => StaffPermissions[accountType];
exports.getDefaultStaffPermissions = getDefaultStaffPermissions;
const getDefaultManagerPermissions = (accountType) => ManagerPermissions[accountType];
exports.getDefaultManagerPermissions = getDefaultManagerPermissions;
const getDefaultAdminPermissions = (accountType) => AdminPermissions[accountType];
exports.getDefaultAdminPermissions = getDefaultAdminPermissions;
//# sourceMappingURL=Permissions.js.map